// По умолчанию API работает на том же домене через nginx.
// Это не привязывает браузер к закрытому внутреннему порту backend.
const BASE_URL = process.env.REACT_APP_API_URL || '';

export const API_URL = BASE_URL;

export const API_CONFIG = {
  BASE_URL: BASE_URL,
  BITRIX_URL: process.env.REACT_APP_BITRIX_PORTAL_URL || ''
};
